//Node Modules
import { useAtom } from "jotai";

//Assets
import { ReactComponent as LogoSimple } from "../../assets/img/logo/kpp-logo-full.svg";
import { ReactComponent as InstagramIcon } from "../../assets/img/social/instagram.svg";
import { ReactComponent as LinkedInIcon } from "../../assets/img/social/linkedin.svg";

//Helpers
import { email, insta, linkedIn, phone, phoneUI } from "../../config/contact/contact";
import { LinkUnderline } from "../helpers";
import { navRoutes } from "../../config/nav/navRoutes";
import { previewContentAtom } from "../../state/appState";

const AppFooter = () => {
	const [previewContent, setPreviewContent] = useAtom(previewContentAtom);

	const toggleDraftContent = () => {
		setPreviewContent((currValue) => !currValue);
		window.location.reload();
	};

	return (
		<footer className="appFooter">
			<div className="appFooter-content flexVert aItems-center">
				<div className="appFooter-logo">
					<LinkUnderline side="left" destination="/" text={<LogoSimple />} />
				</div>
				<div className="appFooter-links flex aItems-center gapCol-medium gapRow-small marginTop-medium">
					<LinkUnderline side="bottom" destination={`tel: ${phone}`} text={phoneUI} wrapperClasses="link-light" />
					<span className="divider fontColour-charcoalLight">{`//`}</span>
					<LinkUnderline side="bottom" destination={`mailto: ${email}`} text={email} wrapperClasses="link-light" />
					<span className="divider fontColour-charcoalLight">{`//`}</span>
					<div className="flex aItems-center gap-medium">
						<a href={linkedIn.link} target="blank">
							<LinkedInIcon className="socialIcon socialIcon-animate" />
						</a>
						<a href={insta.link} target="blank">
							<InstagramIcon className="socialIcon socialIcon-animate" />
						</a>
					</div>
				</div>
				<div className="appFooter-legal marginTop-medium flex gap-small jContent-center">
					<LinkUnderline side="top" destination={navRoutes.privacy} text="Privacy Policy" />
					<span className="divider fontColour-charcoalLight">{`//`}</span>
					<span>&copy; {new Date().getFullYear()} KPP Architects Ltd.</span>
				</div>
			</div>
			{process.env.REACT_APP_CONTENT_PREVIEW !== "false" && (
				<div className="preview fontSize-small">
					<input type="checkbox" id="previewContent" checked={previewContent} onChange={() => toggleDraftContent()} />
					<label htmlFor="previewContent">Enable Draft Content</label>
				</div>
			)}
		</footer>
	);
};

export default AppFooter;
